import * as singleSpa from "single-spa";
import {
  isLoggedRoute,
  checkLead,
  addErrorHandler,
  initMonitoring,
  initHotjar,
} from "./utils";
import { registerApplications } from "./registerApplications";
import { logWhenChangeRoute } from "./utils/logWhenChangeRoute";
import { sendPageViewEventWhenChangeRoute } from "./utils/sendPageViewEventWhenChangeRoute";
import { identifyLeadForAnalyticEvents } from "./utils/identifyLeadForAnalyticEvents";

function init() {
  if (isLoggedRoute) {
    checkLead();
    identifyLeadForAnalyticEvents();
  } else {
    singleSpa.start({ urlRerouteOnly: true });
  }
}

initMonitoring();
registerApplications();
sendPageViewEventWhenChangeRoute();
logWhenChangeRoute();
addErrorHandler();
init();
initHotjar();
